import {
  ProductSummary,
  productSummaryFromResponse,
} from '../interfaces/Product/ProductSummary';
import api, { apiPrefix } from './Api';
import {
  GetProductsRequest,
  getProductsRequestToParams,
} from '../interfaces/Product/GetProductsRequest';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import { Product, productFromResponse } from '../interfaces/Product/Product';
import { ProductPopularity } from '../interfaces/Product/ProductPopularity';

const getUrlByPopularity = (popularity: ProductPopularity) => {
  switch (popularity) {
    case 'daily':
      return 'daily-products';
    case 'highlighted':
      return 'highlights-products';
    default:
      return 'popular-products';
  }
};

export const getProductsByPopularity = async (
  popularity: ProductPopularity,
): Promise<ProductSummary[]> => {
  const response = await api.get(
    `${apiPrefix}/${getUrlByPopularity(popularity)}`,
  );

  return (
    popularity === 'daily' ? response.data?.data?.products : response.data?.data
  ).map(productSummaryFromResponse);
};

export const getProductsByBrand = async (
  brandSlug: string,
  req: GetProductsRequest,
): Promise<PaginatedResponse<ProductSummary>> => {
  const response = await api.get(`${apiPrefix}/productsByBrand/${brandSlug}`, {
    params: getProductsRequestToParams(req),
  });

  return {
    data: (response.data?.data ?? []).map((p: any) =>
      productSummaryFromResponse(p),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getProductsByCategory = async (
  categorySlug: string,
  req: GetProductsRequest,
): Promise<PaginatedResponse<ProductSummary>> => {
  const response = await api.get(
    `${apiPrefix}/productsByCategory/${categorySlug}`,
    {
      params: getProductsRequestToParams(req),
    },
  );

  return {
    data: (response.data?.data?.data ?? []).map((p: any) =>
      productSummaryFromResponse(p),
    ),
    totalCount: response.data?.data?.total_count ?? 0,
  };
};

export const getProductsByOffer = async (
  offerID: number,
  req: GetProductsRequest,
): Promise<PaginatedResponse<ProductSummary>> => {
  const response = await api.get(`${apiPrefix}/products/offer/${offerID}`, {
    params: getProductsRequestToParams(req),
  });

  return {
    data: (response.data?.data?.data ?? []).map((p: any) =>
      productSummaryFromResponse(p),
    ),
    totalCount: response.data?.data?.total_count ?? 0,
  };
};

export const getRelatedProducts = async (
  productID: number,
): Promise<ProductSummary[]> => {
  const response = await api.get(`${apiPrefix}/relatedProducts`, {
    params: { productId: productID },
  });

  return (response.data?.data ?? []).map(productSummaryFromResponse);
};

export const getProduct = async (slug: string): Promise<Product> => {
  const response = await api.get(`${apiPrefix}/products/${slug}`);

  return productFromResponse(response.data?.product);
};
